//
//
//
//
//
//
//
//
//
//
//
//
//

import HomeGameWheel from './HomeGameWheel.vue';
import HomeGameCharacter from './HomeGameCharacter.vue';

import { GameStatus } from '../wheel.entity';

export default {
  name: 'WheelHomeGame',
  components: {
    HomeGameWheel,
    HomeGameCharacter
  },
  props: {
    // 假设通过 props 传入 state 或全局状态管理器数据
    wheelState: {
      type: Object,
      default: () => ({ game: null })
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  computed: {
    wheelGame() {
      return this.wheelState ? this.wheelState.game : null;
    },
    gameStatus() {
      if (!this.wheelGame) {
        return GameStatus.CREATED;
      }
      return this.wheelGame.status;
    },
    // 匹配 max-width: 767px (对应 breakpoint sm)
    isSm() {
      return this.windowWidth <= 767;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    }
  }
};
